import React from "react";
import ImageGallery from "react-image-gallery";
// import stylesheet-ul galeriei
import "react-image-gallery/styles/css/image-gallery.css";

import ContributiiImg from "../images/contributii-img.png";

const images = [
  {
    original: ContributiiImg,
    thumbnail: ContributiiImg,
  },
  {
    original: ContributiiImg,
    thumbnail: ContributiiImg,
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
];

const ProdusGallery = () => {
  return <ImageGallery items={images} />;
};

export default ProdusGallery;
